import { render, staticRenderFns } from "./Silverdor.vue?vue&type=template&id=f9f8432c&scoped=true&"
import script from "./Silverdor.vue?vue&type=script&lang=js&"
export * from "./Silverdor.vue?vue&type=script&lang=js&"
import style0 from "./Silverdor.vue?vue&type=style&index=0&id=f9f8432c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f8432c",
  null
  
)

export default component.exports